import React from 'react';
import CommonModal from '../common/Modal';

export const SessionExpiredModal = props => {
  return (
    <div className="sessionExpiredModal">
      <CommonModal isInitialFocusToClose={true} isFocusOutside={true}>
        <div className="topHeading">You've been logged out</div>
        <div className="idleTimerConfirmModal soundGoodModal">
          <p>
            Your account has been logged out due to a session time limit. Please
            log back in to continue.
          </p>
          <div className="action-button">
            <button
              className="button soundGoodButton"
              onClick={props.clearData}
            >
              Sounds good
            </button>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};
